import { useGetOne } from "ra-core";
import { useMemo } from "react";

import { AJUSTES_POR_DEFECTO, leerAjustes } from "../dominio/ajustes";
import type { AjustesNevora } from "../dominio/tipos";

/**
 * Ajustes Nevora (umbrales del semáforo, intentos, sectores) leídos de
 * `configuration.config.nevora`. Mientras cargan, los valores por defecto.
 */
export const useAjustes = (): { ajustes: AjustesNevora; cargando: boolean } => {
  const { data, isPending } = useGetOne<{ id: number; config?: unknown }>(
    "configuration",
    { id: 1 },
    { staleTime: 60 * 1000 },
  );
  const ajustes = useMemo(
    () => (data ? leerAjustes(data.config) : AJUSTES_POR_DEFECTO),
    [data],
  );
  return { ajustes, cargando: isPending };
};
